import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { useStore } from "../context/StoreContext";
import api, { money } from "../lib/api";

const STATUS_LABEL = { pending: "Aguardando pagamento", paid: "Pago", cancelled: "Cancelado", shipped: "Enviado", delivered: "Entregue" };

export default function AccountPage() {
  const { user, authChecked } = useStore();
  const navigate = useNavigate();
  const [orders, setOrders] = useState([]);

  useEffect(() => {
    if (authChecked && !user) navigate("/login");
  }, [authChecked, user, navigate]);

  useEffect(() => {
    if (!user) return;
    let t;
    const fetchOrders = () => api.get("/my-orders").then((r) => setOrders(r.data)).catch(() => {});
    fetchOrders();
    t = setTimeout(fetchOrders, 1200);
    return () => clearTimeout(t);
  }, [user]);

  if (!user) return <div className="min-h-screen bg-background" />;

  return (
    <div data-testid="account-page">
      <Header />
      <main className="max-w-4xl mx-auto px-6 py-16 min-h-[60vh]">
        <p className="label-caps mb-3">Minha conta</p>
        <h1 className="font-display text-4xl tracking-tighter font-medium mb-2" data-testid="account-name">{user.name}</h1>
        <p className="text-zinc-500 text-sm mb-12">{user.email}</p>

        <h2 className="font-display text-2xl tracking-tight mb-6">Meus pedidos</h2>
        {orders.length === 0 ? (
          <p className="text-zinc-500 text-sm py-10" data-testid="account-no-orders">
            Nenhum pedido ainda. <Link to="/" className="text-gold hover:underline">Explorar a loja</Link>.
          </p>
        ) : (
          <div className="space-y-4" data-testid="account-orders">
            {orders.map((o) => (
              <Link key={o.id} to={`/pedido/${o.id}`} data-testid={`account-order-${o.id}`}
                className="flex flex-wrap items-center justify-between gap-4 border border-white/10 rounded-lg p-5 bg-[#111111] hover:border-gold/40 transition-colors">
                <div>
                  <p className="text-sm text-zinc-100">
                    {o.order_number ? `#${String(o.order_number).padStart(4, "0")}` : "Pedido pendente"}
                  </p>
                  <p className="text-xs text-zinc-500 mt-1">{new Date(o.created_at).toLocaleDateString("pt-BR")} · {o.items.length} item(ns)</p>
                </div>
                <div className="text-right">
                  <p className="text-gold font-semibold text-sm">{money(o.total)}</p>
                  <p className={`text-xs mt-1 ${o.status === "paid" ? "text-emerald-400" : "text-amber-500/80"}`} data-testid="account-order-status">
                    {STATUS_LABEL[o.status] || o.status}
                  </p>
                </div>
              </Link>
            ))}
          </div>
        )}
      </main>
      <Footer />
    </div>
  );
}
